// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('campaigns', {
//         templateUrl: 'views/components/views/campaigns/campaigns.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['stateService', 'campaignsComponentService', 'utilityService', 'rememberService', function (stateService, campaignsComponentService, utilityService, rememberService) {
//             const vm = this;
            
//             vm.model = {
//                 mainButtonGroup: {
//                     selected: 'campaigns_active',
//                     remember: stateService.getCurrentName() + ':selected',
//                     buttons: [
//                         { id: 'campaigns_active', label: 'campaigns_active', color: 'primary', onClick: { click: handleButtonClick, id: 'campaigns_active' } },
//                         { id: 'campaigns_scheduled', label: 'campaigns_scheduled', color: 'primary', onClick: { click: handleButtonClick, id: 'campaigns_scheduled' } },
//                         { id: 'campaigns_finished', label: 'campaigns_finished', color: 'primary', onClick: { click: handleButtonClick, id: 'campaigns_finished' } }
//                     ]
//                 },
//                 settings: {},
//                 itemsListCampaigns: []
//             };

//             function setSelected(id) {
//                 return vm.model.mainButtonGroup.selected = vm.model.settings.campaign_selected = id;
//             }

//             function handleButtonClick(id) {
//                 setSelected(id);
//                 handleRemember(vm.model.mainButtonGroup.remember, id);
//                 loadCampaigns(id);
//             }

//             function handleRemember(name, value) {
//                 if (utilityService.validateParmsValue(name) !== true) return;
//                 if (utilityService.validateParmsValue(value) !== true) return;

//                 return rememberService.remember(name, value);
//             }

//             async function loadSetting() {
//                 vm.model.settings = (await campaignsComponentService.get())[0];
//             }

//             async function loadCampaigns(campaign) {
//                 if (utilityService.validateParmsValue(campaign) !== true) return;

//                 vm.model.itemsListCampaigns = await campaignsComponentService.list(campaign);
//             }

//             vm.handleCreateCampaign = function () {
//                 return stateService.go('campaignedit', { campaign_keyno: 0 });
//             }

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 handleButtonClick(vm.model.settings.campaign_selected);
//                 loadCampaigns();
//             }
//         }]
//     });
// })();
